import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { HomesFacade } from '@library/store/homes/homes.facade';
import { Home } from '@library/store/homes/homes.interface';
import { MeasuresFacade } from '@library/store/measures/measures.facade';
import { EnumMeasureTypes, EnumScales, Measure, TimeRange } from '@library/store/measures/measures.interface';
import { Module } from '@library/store/modules/modules.interface';
import { ControlPageStore } from '@pages/control-page/control-page-store.service';
import * as moment from 'moment-timezone';
import { defer, map, switchMap } from 'rxjs';

@Component({
  selector: 'app-dataset-card-preview',
  templateUrl: './dataset-card-preview.component.html',
  styleUrls: ['./dataset-card-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatasetCardPreviewComponent {

  @Input() module: Module;
  @Input() home: Home;
  @Input() measureType: EnumMeasureTypes;

  moduleMeasures$ = defer(() => this.measuresFacade.getModulesMeasures([{id: this.module.id}])).pipe(
    map(([moduleMeasures]) => {
      const timeRange: TimeRange = {
        dateBegin: moment().subtract(12, 'hours'),
        dateEnd: moment(),
      };

      const measures = moduleMeasures[this.measureType]?.[this.controlPageStore.scaleToApiScale(EnumScales.DAY)] ?? [];

      let res = measures
        .filter(m => m.x >= timeRange.dateBegin.valueOf() && m.x <= timeRange.dateEnd.valueOf());

      // If the array of measures is empty, generate an array files with zeros
      if (res.length === 0) {
        res = Array.from(Array(24), (_, i) => ({x: timeRange.dateBegin.clone().add(i * 30, 'minutes').valueOf(), y: 0} as Measure));
      }

      return res;
    })
  );

  homeMeasures$ = this.homesFacade.currentHome$.pipe(
    switchMap(home => this.measuresFacade.getHomeMeasures(home)),
    map((homeMeasures) => {
      const timeRange: TimeRange = {
        dateBegin: moment().subtract(12, 'hours'),
        dateEnd: moment(),
      };

      const measures = homeMeasures[this.measureType]?.[this.controlPageStore.scaleToApiScale(EnumScales.DAY)] ?? [];

      let res = measures
        .filter(m => m.x >= timeRange.dateBegin.valueOf() && m.x <= timeRange.dateEnd.valueOf());

      // If the array of measures is empty, generate an array files with zeros
      if (res.length === 0) {
        res = Array.from(Array(24), (_, i) => ({x: timeRange.dateBegin.clone().add(i * 30, 'minutes').valueOf(), y: 0} as Measure));
      }

      return res;
    })
  );

  constructor(
    public measuresFacade: MeasuresFacade,
    public controlPageStore: ControlPageStore,
    public homesFacade: HomesFacade,
  ) { }
}